import { ListItemBox } from "lib/@components/ListItemBox"
import { Repeat } from "lib/@components/repeat"
import { buildProjectBridgeImportSummaryCards } from "./project-bridge-import-summary-cards-presenters"
import { ProjectBridgeImportSummaryCard } from "./project-bridge-import-summary-card"

export function ProjectBridgeImportSummaryCards({ importRecord, latestRunStatus }) {
    const items = buildProjectBridgeImportSummaryCards({ importRecord, latestRunStatus })

    return (
        <ListItemBox spacing={1} sx={{ flexWrap: "wrap", justifyContent: "stretch", alignItems: "stretch" }}>
            <Repeat list={items} item={<ProjectBridgeImportSummaryCard />} keyFn={keyByItem} />
        </ListItemBox>
    )

    function keyByItem(item) {
        return item?.key
    }
}
